import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  margin-top: -80px;
  margin-bottom: 48px;
  gap: 40px;
  width: 100%;
  padding: 0px 20px;
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
`;

export const WrapperCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
  min-height: 60vh;
  margin-top: inherit;
  @media (min-width: ${({ theme }) => theme.mediaQueries.xs}) {
    min-height: 40vh;
  }
`;

export const ColoredBackground = styled.div<{ $percent: number }>`
  background-color: ${({ theme, $percent }) =>
    $percent >= 75
      ? theme.colors.green8
      : $percent >= 50
      ? theme.colors.orange8
      : theme.colors.red8};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
  padding-top: 32px;
  padding-bottom: 250px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.xs}) {
    padding-bottom: 210px;
  }
`;

export const Title = styled.span`
  color: ${({ theme }) => theme.colors.white};
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const SuccesesText = styled.span`
  color: ${({ theme }) => theme.colors.white};
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.2px;
`;
